/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_ReadyInputs */

const en_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const de_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit`)
};

const fr_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const es_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const it_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const nl_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

const pl_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy`)
};

const fi_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmis`)
};

const da_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const sv_onboarding_step_ready = /** @type {(inputs: Onboarding_Step_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Onboarding_Step_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_ready = /** @type {((inputs?: Onboarding_Step_ReadyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_ReadyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_step_ready(inputs)
	if (locale === "fr") return fr_onboarding_step_ready(inputs)
	if (locale === "es") return es_onboarding_step_ready(inputs)
	if (locale === "it") return it_onboarding_step_ready(inputs)
	if (locale === "nl") return nl_onboarding_step_ready(inputs)
	if (locale === "pl") return pl_onboarding_step_ready(inputs)
	if (locale === "fi") return fi_onboarding_step_ready(inputs)
	if (locale === "da") return da_onboarding_step_ready(inputs)
	if (locale === "sv") return sv_onboarding_step_ready(inputs)
	return en_onboarding_step_ready(inputs)
});